import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProductService } from '../../../../../../admin/src/app/services/product.service';
import { Product } from '../../../../../../admin/src/app/models/product';
import { MatomoTracker } from 'ngx-matomo';

@Component({
  selector: 'app-product-information',
  templateUrl: './product-information.component.html',
  styleUrls: ['./product-information.component.css']
})
export class ProductInformationComponent implements OnInit, OnDestroy {

  productId: string;

  product: Product;

  sub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private productSvc: ProductService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.matomoTracker.trackPageView('Product information');

    this.sub = this.route.parent.paramMap.subscribe(params => {
      this.productId = params.get('productId');
      this.getProduct();
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  getProduct() {
    this.productSvc.get(this.productId).subscribe(data => {
      this.product = Object.assign({}, data.payload);
    });
  }

}
